import { Fragment, useState } from "react";
import { Card, CardBody, Col, Popover, PopoverBody, PopoverHeader } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonPopover from "../Common/CommonPopover";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BasicPopoverTitle, HurryUp } from "../../../../Constants/Constants";
import { BasicPopoverData, BasicPopoverSubTitle } from "../../../../Data/UiKits/Popover";

const BasicPopover = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BasicPopoverTitle} span={BasicPopoverSubTitle} />
        <CardBody className="common-flex popover-wrapper">
          <Btn color="primary" className="example-popover" id="Popover1" onClick={toggle}>
            {HurryUp}
          </Btn>
          <Popover placement="left" isOpen={popover} target="Popover1" toggle={toggle}>
            <PopoverHeader>{"Basic Popover"}</PopoverHeader>
            <PopoverBody>{"If the package restore doesn't help, you can look at the Output window in the Visual Studio."}</PopoverBody>
          </Popover>
          {BasicPopoverData &&
            BasicPopoverData.map((item, index) => (
              <Fragment key={index}>
                <CommonPopover data={item} />
              </Fragment>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicPopover;
